<template>
  <div class="app-container other-points-statistical-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('其他积分统计')">导出</el-button>
        </el-form>
      </div>
    </div>
<!--    <div class="chart-tile-section">
      <div class="chart-tile-item" v-for="(item, index) in tileData" :key="index">
        <div class="label">{{item.label}}</div>
        <div class="value">{{item.value}}</div>
      </div>
    </div> -->
    <div class="chart-container">
      <div class="chart-item">
        <div class="chart-item-canvas-full" id="sasOtherPointsConsumeChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-canvas-full" id="sasPointsPayChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisOtherPoints',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        communityId: '',
        siteId: ''
      },
      communityOptions: [],
      siteOptions: [],
      chartEle: {
        consumeChart: null,
        payChart: null
      },
      exchangeType: {
        1: '线下',
        2: '线上',
        3: '代投',
        4: '扫描固定二维码'
      },
      tileData: [
        { label: '积分累计发放总量：', value: 0 },
        { label: '积分消耗量：', value: 0 },
        { label: '积分余量池：', value: 0 }
      ]
    }
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.otherStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          communityId: '',
          siteId: ''
        }
      }
      this.initPage()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = '站点' + (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalOther/otherStatisticalImport',
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 积分统计
    otherStatistical() {
      this.$api.statistical.other.otherStatistical({ dataTimeRange: this.form.dataTimeRange }).then(res => {
        this.$nextTick(() => {
          // this.tileData[0].value = res.data.sumIssueCount
          // this.tileData[1].value = res.data.sumConsumptionCount
          // this.tileData[2].value = res.data.sumRemainingCount
          this.initConsumeChart(this.transResData(res.data.statisticalOtherConsumptionResult, 1))
          this.initPayChart(this.transResData(res.data.statisticalOtherIssueResult, 1))
        })
      })
    },
    // 消耗
    initConsumeChart(data) {
      this.chartEle.consumeChart = this.$echarts.init(document.getElementById('sasOtherPointsConsumeChart'))
      const xNames = []
      for (const item of data.xNames) {
        xNames.push(this.$wtConst.integralType[item])
      }
      const options = this.createOption({
        title: { text: '积分消耗', left: 'center' },
        color: ['#d19300'],
        // legend: { left: 'center', bottom: 'bottom', data: ['积分消耗'] },
        grid: { right: 0, left: 100, bottom: 140 },
        xNames: xNames,
        series: [
          {
            name: '积分消耗',
            type: 'bar',
            data: data.y1Names
          }
        ]
      })
      options.xAxis[0].axisLabel = {
        rotate: 50
      }
      this.chartEle.consumeChart.setOption(options)
    },
    // 发放
    initPayChart(data) {
      this.chartEle.payChart = this.$echarts.init(document.getElementById('sasPointsPayChart'))
      const xNames = []
      for (const item of data.xNames) {
        xNames.push(this.$wtConst.integralType[item])
      }
      const options = this.createOption({
        title: { text: '积分发放', left: 'center' },
        color: ['#98c58c'],
        // legend: { left: 'center', bottom: 'bottom', data: ['积分发放'] },
        grid: { right: 0, left: 100, bottom: 140 },
        xNames: xNames,
        series: [
          {
            name: '积分发放',
            type: 'bar',
            data: data.y1Names
          }
        ]
      })
      options.xAxis[0].axisLabel = {
        rotate: 50
      }
      this.chartEle.payChart.setOption(options)
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.other-points-statistical-container {
  .chart-container {
    .chart-item {
      height: 600px;
    }
  }
}
</style>
